import { Component, inject, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { alertConfig } from './alert-modal.constants';

@Component({
  selector: 'app-alert-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './alert-modal.component.html',
  styleUrl: './alert-modal.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-in-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]
})
export class AlertModalComponent {
  private readonly alertService = inject(AlertService);
  readonly alert = this.alertService.alert;

  readonly title = computed(() => {
    const data = this.alert();
    if (!data) return '';

    return alertConfig[data.type]?.title ?? '';
  });

  readonly message = computed(() => {
    const data = this.alert();
    if (!data) return '';

    return data.subtitle ?? alertConfig[data.type]?.defaultMessage ?? '';
  });
}
